export default "__VITE_ASSET__DiAZ6Rok__"